import React, { Component } from 'react'
import {
  Button,
  TableRow,
  TableCell,
  Table,
  TableBody,
  withStyles
} from '@material-ui/core'
import { useForm, Form, Field } from '../../form'

const styles = (theme) => ({
  textField: {
    fontSize: '15px',
    marginTop: theme.spacing(3),
    width: '100%'
  },
  tableCell: {
    border: 'none'
  }
})

class AdminUserFilterRow extends Component {
  render() {
    return <AdminUserFilterRowComponent {...this.props} />
  }
}

export default withStyles(styles)(AdminUserFilterRow)

const defaultValues = {
  firstname: '',
  lastname: '',
  email: '',
  ssn: '',
  phone: ''
}

const AdminUserFilterRowComponent = ({ searchAdminUsers, classes }) => {
  const form = useForm({
    name: 'adminSearchCustomer',
    onSubmit: onSubmit,
    defaultValues: defaultValues,
    resetOnSubmit: false
  })

  const { control } = form

  function onSubmit(values) {
    searchAdminUsers(values)
  }

  return (
    <Form {...form}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell className={classes.tableCell}>
              <Field
                name="firstname"
                label="Etunimi"
                className={classes.textField}
                inputType="textfield"
                control={control}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="lastname"
                label="Sukunimi"
                className={classes.textField}
                inputType="textfield"
                control={control}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="email"
                label="Sähköposti"
                className={classes.textField}
                inputType="textfield"
                control={control}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="ssn"
                label="Henkilötunnus"
                className={classes.textField}
                inputType="textfield"
                control={control}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Field
                name="phone"
                label="Puhelinnumero"
                className={classes.textField}
                inputType="textfield"
                control={control}
              />
            </TableCell>
            <TableCell className={classes.tableCell}>
              <Button
                className="pull-right"
                type="submit"
                variant="contained"
                style={{ width: '80px' }}
              >
                HAE
              </Button>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Form>
  )
}
